import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CustomValidatorsService {
  confirmCaseInsensitive(confirmFieldInput: string) {
    let confirmFieldControl: UntypedFormControl;
    let fieldControl: UntypedFormControl;

    return (control: UntypedFormControl) => {
      if (!control.parent) {
        return null;
      }

      if (!confirmFieldControl) {
        confirmFieldControl = control;
        fieldControl = control.parent.get(confirmFieldInput) as UntypedFormControl;
        fieldControl.valueChanges.subscribe(() => {
          confirmFieldControl.updateValueAndValidity();
        });
      }

      if (fieldControl.value !== confirmFieldControl.value) {
        return {
          notMatch: true
        };
      }
      return null;
    };
  }

  confirmCaseSensitive(confirmFieldInput: string) {
    let confirmFieldControl: UntypedFormControl;
    let fieldControl: UntypedFormControl;

    return (control: UntypedFormControl) => {
      if (!control.parent) {
        return null;
      }

      if (!confirmFieldControl) {
        confirmFieldControl = control;
        fieldControl = control.parent.get(confirmFieldInput) as UntypedFormControl;
        fieldControl.valueChanges.subscribe(() => {
          confirmFieldControl.updateValueAndValidity();
        });
      }

      if (fieldControl.value !== confirmFieldControl.value) {
        return {
          notMatch: true
        };
      }
      return null;
    };
  }
}
